module.exports = __webpack_public_path__ + "static/assets/10a5c3a39ad67c12eeb6183fe427129b.svg";